import {fabric} from 'fabric';
import React, {createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState} from 'react';

interface EventCreateStickerContextType {
  canvas: fabric.Canvas | null;
  setCanvas: Dispatch<SetStateAction<fabric.Canvas | null>>;
}
type ProviderProps = {children: ReactNode};

const defaultContextValue: EventCreateStickerContextType = {
  canvas: null,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: no empty block
  setCanvas: () => {},
};

export const EventCreateStickerContext =
  createContext<EventCreateStickerContextType>(defaultContextValue);

export const EventCreateStickerParent: React.FC<ProviderProps> = ({children}) => {
  const [canvas, setCanvas] = useState<fabric.Canvas | null>(null);

  const value = useMemo(() => ({canvas, setCanvas}), [canvas]);

  return (
    <EventCreateStickerContext.Provider value={value}>
      {children}
    </EventCreateStickerContext.Provider>
  );
};
